import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)

const store = new vuex.Store({
  state: {
    hasShownTreeSelectionPageTip: false,
    selectedTreeTabIdx: -1,
  },
  getters: {
    needShowTreeSelectionPageTip: state => {
      return !state.hasShownTreeSelectionPageTip
    },
    selectedTreeTabIdx: state => {
      return state.selectedTreeTabIdx
    }
  },
  mutations: {
    recordShownTreeSelectionPageTip (state) {
      state.hasShownTreeSelectionPageTip = true
    },
    setSelectedTreeTabIdx(state, v) {
      state.selectedTreeTabIdx = v
    }
  },
  actions: {
    // setTest(context, params){
    //   context.commit('setTest', params)
    // },
  }
})

export default store
